<num-value-select
  [value]="value"
  (selectedValue)="setValue($event)"
  [label]="'FEASIBILITY.EDITOR.QUANTITY.VALUE'"
></num-value-select>
